import { styled } from '../../../../../stitches.config';
import { PriceButton, PriceButtonProps } from './PriceButton';

const Container = styled('div', {
  position: 'absolute',
  left: 0,
  top: '50%',
  transform: 'translateY(-50%)',
});

interface RootPriceProps extends PriceButtonProps {}

export function RootPrice(props: RootPriceProps) {
  return (
    <Container>
      <PriceButton {...props} />
    </Container>
  );
}
